// Contact Location component 
import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import '../styles/ContactLocation.css';
import { ContactForm } from "./CTAForm";

function ContactLocation() {
    return (
        <div className="contact-location-component">
            <NavBar />
            <div className="contact-location">
                <h1>Our Doors Are Always Open – Come Say Hi</h1>

                {/* Google maps location attachment for various bigger screen sizes */}
                <div className="location-on-map-desktop">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7940532895136!2d36.79032887420281!3d-1.2983056986893529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f11e72fd95819%3A0xee3f0e76e786bb41!2sPinetree%20Plaza%20Kaburu%20Drive!5e0!3m2!1sen!2ske!4v1737547500465!5m2!1sen!2ske" 
                        width="900" 
                        height="350" 
                        style={{ border:0 }} 
                        allowfullscreen="" 
                        loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade"
                        title="Pinetree Plaza Location - Desktop"
                    ></iframe>
                </div>

                {/* Google maps location attachment for various smaller screen sizes */}
                <div className="location-on-map-mobile">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7940532895136!2d36.79032887420281!3d-1.2983056986893529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f11e72fd95819%3A0xee3f0e76e786bb41!2sPinetree%20Plaza%20Kaburu%20Drive!5e0!3m2!1sen!2ske!4v1737547500465!5m2!1sen!2ske" 
                        width="330" 
                        height="250" 
                        style={{ border:0 }} 
                        allowfullscreen="" 
                        loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade"
                        title="Pinetree Plaza Location - Mobile"
                    ></iframe>
                </div>

                {/* Contact information and location for both countries */}
                <div className="contact-info">
                    <div className="zambia-contact-info">
                        <h3>Zambia's Contact Info</h3>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/location - yellow.png" alt="location icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Address:</h5>
                                <p>215D Napsa Complex, Off Buluwe Rd Lusaka Zambi</p>
                            </div>
                        </div>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/telephone - yellow.png" alt="telephone icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Phone:</h5>
                                <p>+260 760131924</p>
                            </div>
                        </div>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/smartphone - yellow.png" alt="smartphone icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Mobile:</h5>
                                <p>+260 955039262</p>
                            </div>
                        </div>
                    </div>
                    <div className="kenya-contact-info">
                        <h3>Kenya's Contact Info</h3>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/location - yellow.png" alt="location icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Address:</h5>
                                <p>Pinetree Plaza, 8th Floor, Kaburu Drive, Ngong Road</p>
                            </div>
                        </div>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/telephone - yellow.png" alt="telephone icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Phone:</h5>
                                <p>+254204938470</p>
                            </div>
                        </div>
                        <div className="contact-info-card">
                            <div className="vector-div">
                                <img src="/images/smartphone - yellow.png" alt="smartphone icon" />
                            </div>
                            <div className="contact-info-details">
                                <h5>Mobile:</h5>
                                <p>+254 703 785199</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Email address and website links */}
                <div className="email-and-website">
                    <div className="contact-info-card">
                        <div className="vector-div">
                            <img src="/images/mail - yellow.png" alt="mail icon" />
                        </div>
                        <div className="contact-info-details">
                            <h5>Email:</h5>
                            <a href="mailto:admin@signifide.group" target="_blank" rel="noopener noreferrer">admin@signifide.group</a>
                        </div>
                    </div>
                    <div className="contact-info-card">
                        <div className="vector-div">
                            <img src="/images/internet - yellow.png" alt="website link icon" />
                        </div>
                        <div className="contact-info-details">
                            <h5>Website:</h5>
                            <a href="https://signifide.group/" target="_blank" rel="noopener noreferrer">signifide.group</a>
                        </div>
                    </div>

                </div>

                {/* Contact form component */}
                <div className="cta-form-container">
                    <h3>Get In Touch!</h3>
                    <ContactForm />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ContactLocation;